import View from '@/base/views/view';

class DeploymentView extends View {

    static table = 'deployment';

    static options () {
        let obj = {
            fields: [
                { name: 'build_id', label: 'Build ID', editor: 'text', columns: 2 },
                { name: 'build_arn', label: 'Build ARN', editor: 'text', required: false, columns: 2 },
                { name: 'environment', label: 'Entorno', editor: 'text', columns: 1 },
                { name: 'start_time', label: 'Inicio', editor: 'datetime', required: true, columns: 2 },
                { name: 'end_time', label: 'Finalización', editor: 'datetime', required: true, columns: 2 },
                { name: 'duration', label: 'Duración S', editor: 'number', required: true, columns: 1 },
                { name: 'status', label: 'Estado', editor: 'vue-select', required: true, columns: 2, options: [
                    { value: 'PENDING', label: 'Pendiente' },
                    { value: 'IN_PROGRESS', label: 'En progreso' },
                    { value: 'SUCCEEDED', label: 'Finalizado' },
                    { value: 'FAILED', label: 'Fallido' },
                    { value: 'STOPPED', label: 'Detenido' },
                    { value: 'TIMED_OUT', label: 'Tiempo de espera agotado' },
                ] },
                { name: 'UserId', label: 'Usuario', editor: 'vue-select', relation:'user', optionLabels: 'Name', columns: 1 },
                { name: 'error_message', label: 'Mensaje de error', editor: 'text-area', columns: 12, rows: 20 },
            ]
        }
        return obj
    }

    static async getTableOptions () {
        let res = await super.getTableOptions(this.options());
        return res;
    }

}

export default DeploymentView;
